// extracted by mini-css-extract-plugin
module.exports = {"notification":"_3z7wra4AlpLKDJwXhXdBdp","content":"_1oYWtOu4PUMnWFvneTYOUr"};